import { AimOutlined } from "@ant-design/icons";
import { CrudOp, targetAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { TargetManagerView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator) => {
  const authHelper = authHelperCreator(targetAuthScope);
  return authHelper.evaluate(CrudOp.READ);
};

export const targetManagerViewKey = "project_modular_target-manager/:brand/:projectId/:tmmId";
export const targetManagerViewModule: ViewModule = {
  viewKey: targetManagerViewKey,
  viewEl: <TargetManagerView/>,
  displayNameI18nKey: "target-manager:viewName",
  menuIconEl: <AimOutlined/>,
  isAuthorized,
  translations,
};
